module.exports = __webpack_public_path__ + "img/jordi-profile.11712537.png";